import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IResponse, RefType, WithMetadata } from '@/types';

@Injectable({
  providedIn: 'root',
})
export class RefTypeService {
  BASEURL = `${environment.api.paramsUrl}/ref-types`;
  httpClient = inject(HttpClient);

  getRefTypes(params?: any): Observable<IResponse<RefType>> {
    return this.httpClient.get<IResponse<RefType>>(`${this.BASEURL}`, { params });
  }

  getOneRefType(id: number): Observable<WithMetadata<RefType>> {
    return this.httpClient.get<WithMetadata<RefType>>(`${this.BASEURL}/${id}`);
  }

  addRefType(refType: RefType): Observable<WithMetadata<RefType>> {
    return this.httpClient.post<WithMetadata<RefType>>(`${this.BASEURL}`, refType);
  }

  updateRefType(refType: RefType): Observable<WithMetadata<RefType>> {
    return this.httpClient.put<WithMetadata<RefType>>(`${this.BASEURL}`, refType);
  }

  deleteRefType(id: number): Observable<WithMetadata<RefType>> {
    return this.httpClient.delete<WithMetadata<RefType>>(`${this.BASEURL}/${id}`);
  }
}
